import formatCurrency from "@/utils/formatCurrency";

const CalculatorResultCard = ({ label, value, colorClass = 'teal', large = false }) => {
  const colorStyles = {
    teal: "bg-teal-50 border-teal-200 text-teal-600",
    blue: "bg-blue-50 border-blue-200 text-blue-600",
    green: "bg-green-50 border-green-200 text-green-600",
    red: "bg-red-50 border-red-200 text-red-600",
    gray: "bg-gray-50 border-gray-200 text-gray-600"
  };
  const style = colorStyles[colorClass] || colorStyles.teal;

  return (
    <div className={`p-4 rounded-xl border ${style.split(' ').slice(0, 2).join(' ')}`}>
      <p className="text-sm text-gray-600 mb-1">{label}</p>
      <p className={`font-bold ${style.split(' ')[2]} ${large ? 'text-2xl' : 'text-xl'}`}>
        ₹{formatCurrency(value)}
      </p>
    </div>
  );
};

export default CalculatorResultCard;
